var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "14px" } },
    [
      _c(
        "el-row",
        { staticClass: "row-top", attrs: { gutter: 24 } },
        [
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", [
              _c("img", {
                attrs: { src: require("@/assets/call/phone1.png"), alt: "" },
              }),
              _c("div", [
                _c("h5", { staticStyle: { color: "#374FB8" } }, [
                  _vm._v(_vm._s(_vm.seatsData.callDurationCount || "00:00")),
                ]),
                _c("p", [_vm._v("通话时长")]),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", [
              _c("img", {
                attrs: { src: require("@/assets/call/phone2.png"), alt: "" },
              }),
              _c("div", [
                _c("h5", { staticStyle: { color: "#27D5DF" } }, [
                  _vm._v(_vm._s(_vm.seatsData.callSuccessCount || "0")),
                ]),
                _c("p", [_vm._v("拨通数")]),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", [
              _c("img", {
                attrs: { src: require("@/assets/call/phone3.png"), alt: "" },
              }),
              _c("div", [
                _c("h5", { staticStyle: { color: "#FF414F" } }, [
                  _vm._v(_vm._s(_vm.seatsData.callFailCount || "0")),
                ]),
                _c("p", [_vm._v("未通数")]),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", [
              _c("img", {
                attrs: { src: require("@/assets/call/phone4.png"), alt: "" },
              }),
              _c("div", [
                _c("h5", { staticStyle: { color: "#FFB85A" } }, [
                  _vm._v(_vm._s(_vm.seatsData.percent || "0%")),
                ]),
                _c("p", [_vm._v("接通率")]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "div-screen" }, [
        _c(
          "div",
          { staticClass: "div-row" },
          [
            _c("span", { staticClass: "span-lable" }, [_vm._v("外呼员工：")]),
            _c("el-cascader", {
              ref: "cascader",
              staticStyle: { width: "280px" },
              attrs: {
                "popper-class": "cascader-department",
                size: "small",
                filterable: "",
                placeholder: "请选择外呼员工",
                options: _vm.options,
                "show-all-levels": false,
                props: _vm.props1,
                "collapse-tags": "",
                clearable: "",
              },
              on: { change: _vm.changeCascader },
              model: {
                value: _vm.ownerValue,
                callback: function ($$v) {
                  _vm.ownerValue = $$v
                },
                expression: "ownerValue",
              },
            }),
            _c("span", { staticClass: "span-lable" }, [_vm._v("部门：")]),
            _c("el-cascader", {
              staticClass: "mr-10",
              staticStyle: { width: "280px" },
              attrs: {
                options: _vm.departmentList,
                "popper-class": "cascader-department",
                filterable: "",
                "show-all-levels": false,
                props: _vm.props,
                size: "small",
                placeholder: "请选择部门",
                "collapse-tags": "",
                clearable: "",
              },
              on: { change: _vm.changeDepartment },
              model: {
                value: _vm.cascader,
                callback: function ($$v) {
                  _vm.cascader = $$v
                },
                expression: "cascader",
              },
            }),
            _c("a", { staticClass: "a-btn", on: { click: _vm.clickReset } }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/call/icon-chongzhi.png"),
                  alt: "",
                },
              }),
              _vm._v(" 重置"),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "div-row" },
          [
            _c("span", { staticClass: "span-lable" }, [_vm._v("拨打时间：")]),
            void 0,
            _vm._l(_vm.timeOption, function (item, index) {
              return _c(
                "span",
                {
                  key: index,
                  staticClass: "span-option",
                  class: item.value === _vm.timeChooseType ? "is-select" : " ",
                  on: {
                    click: function ($event) {
                      return _vm.clickTime(item.value)
                    },
                  },
                },
                [_vm._v(_vm._s(item.name))]
              )
            }),
            _c(
              "span",
              {
                staticClass: "span-option",
                class: _vm.isCustom ? "is-select" : " ",
                staticStyle: { "margin-right": "0px" },
                on: { click: _vm.clickCustom },
              },
              [_vm._v("自定义")]
            ),
            _vm.isCustom
              ? _c("el-date-picker", {
                  staticClass: "ml-20",
                  staticStyle: { width: "250px" },
                  attrs: {
                    size: "mini",
                    clearable: false,
                    type: "daterange",
                    "value-format": "yyyy-MM-dd",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                  },
                  on: { change: _vm.changeDate },
                  model: {
                    value: _vm.date,
                    callback: function ($$v) {
                      _vm.date = $$v
                    },
                    expression: "date",
                  },
                })
              : _vm._e(),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "div-row" },
          [
            _c("span", { staticClass: "span-lable" }, [_vm._v("状态：")]),
            _vm._l(_vm.stateList, function (item, index) {
              return _c(
                "span",
                {
                  key: index,
                  staticClass: "span-option",
                  class: item.value === _vm.callStatus ? "is-select" : " ",
                  on: {
                    click: function ($event) {
                      return _vm.clickState(item.value)
                    },
                  },
                },
                [_vm._v(_vm._s(item.name))]
              )
            }),
          ],
          2
        ),
      ]),
      _c(
        "div",
        { staticClass: "div-table" },
        [
          _c("p", { staticClass: "p-title mt-10 mb-20" }, [
            _vm._v("呼叫明细 "),
            _c(
              "span",
              { staticClass: "fr" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.exportSeatsData },
                  },
                  [_vm._v("导出")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { color: "#333" },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", type: "selection", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { prop: "callSeatsName", label: "姓名", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "callSum", label: "全部呼叫" },
              }),
              _c("el-table-column", {
                attrs: { prop: "callSuccessCount", label: "接通数" },
              }),
              _c("el-table-column", {
                attrs: { prop: "callFailCount", label: "未接通数" },
              }),
              _c("el-table-column", {
                attrs: { prop: "callCompletingRate", label: "接通率" },
              }),
              _c("el-table-column", {
                attrs: { prop: "callDuration", label: "通话时长" },
              }),
              _c("el-table-column", {
                attrs: { prop: "callDurationAvg", label: "平均通话时长" },
              }),
            ],
            1
          ),
          _c("pagination", {
            staticStyle: { "margin-top": "60px" },
            attrs: {
              "page-num": _vm.pageNum,
              "page-size": _vm.pageSize,
              total: _vm.total,
            },
            on: {
              sizeChange: _vm.handleSizeChange,
              currentChange: _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }